import React from 'react';

const WebAPIDescription = () => {

    return (
        <div style={{ paddingBottom: '100px' }}>
            <div className='ui grid'>
                <div className="centered row">
                    <div className="sixteen wide column centered">
                        <h1 className="ui header">Table for accesible query of data from Web API using Airflow, Dash and Heroku</h1>
                    </div>
                </div>
                <div className='row'>
                    <div className="sixteen wide column">
                        <h2 className="ui header">Description</h2>
                    </div>
                </div>
                <div className='row'>
                    <div className="sixteen wide column">
                        <p>
                            An ecuadorian supermarket shows its prices in a webpage so as to consumer can check product prices. This webpage doesn't allow to effectively filter, sort and search the price for a particular product. In this way, the purpose of this app is to create an app to access the product prices information and improve the accessibility to consumers.
                            The application is made up a Airflow** app that schedules daily updates to the Webpsage database. The Webpage is a plotly's **Dash** app that reads data from a **PostgreSQL** database and present it in a table. The table is capable of filtering and searching. The architecture is discribed in the following figure.
                        </p>
                    </div>
                </div>
                <div className='row'>
                    <div className='sixteen wide column center aligned'>
                        <div className='ui centered medium image'>
                            <img alt="background" src="https://raw.githubusercontent.com/jomavera/webAPIdatatable/main/diagram.png"/>
                        </div>
                    </div>
                </div>
                <div className='spaced row'>
                    <div className="sixteen wide column center aligned">
                        <a href="https://pulldashboard.herokuapp.com/">
                            <div className='ui small button'>
                                <i className='external alternate icon'></i> Check it out
                            </div>
                        </a>
                        <a href="https://github.com/jomavera/webAPIdatatable">
                            <div className='ui small button'>
                                <i className='github icon'></i> Repo
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default WebAPIDescription;